
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import AuthUserMixin from '@/mixins/AuthUserMixin';
import AppDrawerMixin from '@/mixins/AppDrawerMixin';

@Component
export default class Dashboard extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
  AuthUserMixin,
  AppDrawerMixin,
) {
  availableLocales = [
    {
      code: 'en',
      file: 'en.json',
      name: 'English',
    },
    {
      code: 'id',
      file: 'id.json',
      name: 'Indonesia',
    },
  ];

  async logout() {
    await this.$store.dispatch('auth/logout');
    this.$router.push({
      name: 'login',
      query: {
        logged_out: '1',
      },
    });
  }
}
